import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../api/api";

export default function LatestArticlesSidebar() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        API.get("/api/articles/homepage")
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                setArticles(data.slice(0, 6)); // latest 6
            })
            .catch((err) =>
                console.error("Error fetching latest articles:", err)
            );
    }, []);

    return (
        <aside className="hidden lg:block">
            <div className="sticky top-24">
                <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

                    {/* HEADER */}
                    <div className="px-5 py-4 border-b bg-gray-50">
                        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                            ⏱ Just Published
                        </h3>
                    </div>

                    {/* LIST */}
                    <div className="p-4 space-y-5">
                        {articles.length === 0 ? (
                            <p className="text-gray-500 text-sm text-center">
                                No recent articles
                            </p>
                        ) : (
                            articles.map((article, index) => (
                                <Link
                                    key={article.id}
                                    to={`/article/${article.slug}`}
                                    className="flex items-start gap-3 group"
                                >
                                    {/* TIMELINE DOT */}
                                    <div className="flex flex-col items-center mt-1">
                                        <span className="w-2 h-2 rounded-full bg-indigo-500"></span>
                                        {index !== articles.length - 1 && (
                                            <span className="w-px h-full bg-gray-200 mt-1"></span>
                                        )}
                                    </div>

                                    {/* CONTENT */}
                                    <div className="flex-1 pb-1">
                                        <div className="flex items-center gap-2 mb-1">
                                            <span className="text-[11px] font-medium text-indigo-600 bg-indigo-100 px-2 py-0.5 rounded">
                                                {article.category || "Tech"}
                                            </span>
                                            <span className="text-[11px] text-gray-400">
                                                {article.read_time || "Recently published"}
                                            </span>
                                        </div>

                                        <p className="text-sm font-semibold leading-snug text-gray-900 group-hover:text-indigo-700 transition line-clamp-2">
                                            {article.title}
                                        </p>
                                    </div>
                                </Link>
                            ))
                        )}
                    </div>

                </section>
            </div>
        </aside>
    );
}
